import React, { lazy } from 'react';
// Bonuses.tsx

const nivel1Summary = ['📚 6 Tomos — toda la carrera organizada', '🎁 6 Bonos — guías, tablas y plantillas'];
// Imágenes individuales por tomo extra — cambiá cada constante para subir su imagen propia
const TOMO_7_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_240/v1779122994/ChatGPT_Image_18_may_2026_01_49_09_p.m_piussm.webp';
const TOMO_8_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779123306/ChatGPT_Image_18_may_2026_01_54_37_p.m_aamrdm.webp';
const nivel2Extras = [{
  number: '07',
  title: 'Sistema de Estudio y Organización de la Cursada',
  desc: 'Cronograma por cuatrimestre, planificador de parciales y finales, sistema de repaso.',
  emoji: '🗂️',
  image: TOMO_7_IMG
}, {
  number: '08',
  title: 'Taller de Escritura Académica y TPs',
  desc: 'Modelos de TPs, informes y presentaciones con el formato y lenguaje que piden los docentes.',
  emoji: '✍️',
  image: TOMO_8_IMG
}];
const nivel2Summary = ['📚 6 Tomos', '🎁 6 Bonos', '🗂️ Tomo 07', '✍️ Tomo 08'];
const editables = [{
  emoji: '📋',
  title: 'Planificador semanal'
}, {
  emoji: '📅',
  title: 'Cronograma de cursada'
}, {
  emoji: '✅',
  title: 'Checklist de parciales'
}, {
  emoji: '📊',
  title: 'Seguimiento de materias'
}, {
  emoji: '📝',
  title: 'Resumen por materia'
}, {
  emoji: '🗂️',
  title: 'Organizador de apuntes'
}, {
  emoji: '💊',
  title: 'Fórmulas y cálculos'
}, {
  emoji: '🏥',
  title: 'Práctica hospitalaria'
}, {
  emoji: '📈',
  title: 'Evaluación nutricional'
}, {
  emoji: '🎯',
  title: 'Trabajo final'
}, {
  emoji: '📌',
  title: 'Mapa entre materias'
}];
const rows = [editables.slice(0, 3), editables.slice(3, 6), editables.slice(6, 9), editables.slice(9, 11)];
export function Bonuses() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-12 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(220,252,231) 20%, rgb(187,247,208) 55%, rgb(220,252,231) 75%, rgb(255,255,255) 100%)'
  }} data-id="element-36">
      <div className="mx-auto max-w-4xl" data-id="element-37">
        {/* ── SISTEMA CARRERA ORGANIZADA ── */}
        <div className="flex items-center justify-center gap-2 mb-2" data-id="element-38">
          <span className="h-px w-8 bg-green-500" data-id="element-39" />
          <p className="text-xs sm:text-sm font-bold tracking-[2px] uppercase text-green-700 m-0" data-id="element-40">
            Un paso más
          </p>
          <span className="h-px w-8 bg-green-500" data-id="element-41" />
        </div>

        <h2 className="text-2xl sm:text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-42">
          Sistema Carrera Organizada™
        </h2>
        <p className="text-center text-sm text-gray-600 mx-auto max-w-lg m-0 mb-8" data-id="element-43">
          Todo el Megapack más un sistema para planificar, organizarte y no
          improvisar más.
        </p>

        {/* Resumen Megapack incluido */}
        <div className="bg-white/60 border border-green-300 rounded-xl px-5 py-3 mb-4" data-id="element-44">
          <p className="text-xs font-black text-green-700 uppercase tracking-wide m-0 mb-2" data-id="element-45">
            ✅ Ya incluye todo el Megapack Carrera Resuelta™:
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-46">
            {nivel1Summary.map(item => <span key={item} className="text-[11px] font-semibold text-gray-600 bg-white border border-green-200 rounded-full px-2.5 py-1" data-id="element-47">
                {item}
              </span>)}
          </div>
        </div>

        {/* Tomos nuevos */}
        <div className="bg-white border border-green-400/40 rounded-xl overflow-hidden shadow-sm mb-10" data-id="element-48">
          <div className="px-5 py-2.5 flex items-center justify-between gap-3 bg-green-600" data-id="element-49">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-50">
              ⭐ Lo nuevo en este producto
            </h3>
            <span className="shrink-0 text-[10px] font-bold text-white bg-green-800 rounded-full px-2 py-0.5 whitespace-nowrap" data-id="element-51">
              2 Tomos extra
            </span>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-52">
            {nivel2Extras.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-3" data-id="element-53">
                <span className="shrink-0 text-xl w-8 text-center" data-id="element-54">
                  {tome.emoji}
                </span>
                <div className="flex-1 min-w-0" data-id="element-55">
                  <span className="block text-xs font-black text-gray-900" data-id="element-56">
                    Tomo {tome.number} — {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-57">
                    {tome.desc}
                  </span>
                </div>
                <div className="shrink-0 w-16 h-12 rounded-lg overflow-hidden border border-green-100" data-id="element-58">
                  <img src={tome.image} alt={`Tomo ${tome.number}`} className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-59" />
                </div>
              </div>)}
          </div>
        </div>

        {/* Separador hacia Biblioteca Premium */}
        <div className="flex flex-col items-center gap-2 mb-10" data-id="element-60">
          <p className="text-xs font-bold text-green-700 uppercase tracking-widest m-0" data-id="element-61">
            ¿Querés la versión completa?
          </p>
          <p className="text-sm text-gray-600 text-center m-0" data-id="element-62">
            La Biblioteca Premium Nutrición™ agrega 11 editables para
            personalizar cada materia.
          </p>
          <div className="flex items-center gap-2 mt-1" data-id="element-63">
            <div className="h-px w-16 bg-green-400" data-id="element-64" />
            <span className="text-green-600 text-lg" data-id="element-65">↓</span>
            <div className="h-px w-16 bg-green-400" data-id="element-66" />
          </div>
        </div>

        {/* ── BIBLIOTECA PREMIUM ── */}
        <div className="relative rounded-2xl overflow-hidden shadow-xl mb-6 border-2 border-green-500" style={{
        backgroundImage: 'linear-gradient(135deg, rgb(20,83,45) 0%, rgb(21,128,61) 50%, rgb(22,163,74) 100%)'
      }} data-id="element-67">
          {/* Header interno */}
          <div className="px-6 pt-8 pb-5 text-center" data-id="element-68">
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-69">
              <span className="h-px w-8 bg-green-300/60" data-id="element-70" />
              <p className="text-xs font-bold tracking-[2px] uppercase text-green-300 m-0" data-id="element-71">
                La versión completa
              </p>
              <span className="h-px w-8 bg-green-300/60" data-id="element-72" />
            </div>
            <h2 className="text-2xl sm:text-3xl font-black text-white m-0 mb-2" data-id="element-73">
              🏆 Biblioteca Premium Nutrición™
            </h2>
            <p className="text-sm text-green-100 mx-auto max-w-md m-0" data-id="element-74">
              Todo el Sistema más{' '}
              <strong className="text-yellow-300" data-id="element-75">11 editables premium</strong>{' '}
              para personalizar y dominar cada materia a tu ritmo.
            </p>
          </div>

          {/* Resumen acumulado */}
          <div className="mx-4 mb-4 rounded-xl px-4 py-3 bg-white/10 border border-white/20" data-id="element-76">
            <p className="text-xs font-black text-green-200 uppercase tracking-wide m-0 mb-2" data-id="element-77">
              ✅ Ya incluye todo el Sistema Carrera Organizada™:
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-78">
              {nivel2Summary.map(item => <span key={item} className="text-[11px] font-semibold text-white bg-white/10 border border-white/20 rounded-full px-2.5 py-1" data-id="element-79">
                  {item}
                </span>)}
            </div>
          </div>

          {/* Editables — 3 columnas desktop / 2 mobile centradas */}
          <div className="mx-4 mb-4 bg-white rounded-xl overflow-hidden shadow-sm" data-id="element-80">
            <div className="px-5 py-2.5 flex items-center justify-between gap-3" style={{
            backgroundColor: 'rgb(20,83,45)'
          }} data-id="element-81">
              <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-82">
                ✏️ Lo nuevo: 11 Editables Premium
              </h3>
              <span className="shrink-0 text-[10px] font-black text-green-900 bg-yellow-300 rounded-full px-2 py-0.5 whitespace-nowrap" data-id="element-83">
                EXCLUSIVO
              </span>
            </div>

            <div className="p-4 flex flex-col gap-2" data-id="element-84">
              {rows.map((row, rowIndex) => <div key={rowIndex} className="flex gap-2 justify-center" data-id="element-85">
                  {row.map(item => <div key={item.title} className="flex flex-col gap-1 bg-green-50 border border-green-200 rounded-lg px-3 py-2.5" style={{
                width: 'calc(33.333% - 6px)'
              }} data-id="element-86">
                      <span className="text-lg" data-id="element-87">{item.emoji}</span>
                      <span className="text-[11px] font-semibold text-gray-800 leading-snug flex-1" data-id="element-88">
                        {item.title}
                      </span>
                      <span className="text-[10px] font-bold text-green-700 w-fit border border-green-200 rounded-full px-2 py-0.5 bg-white" data-id="element-89">
                        editable
                      </span>
                    </div>)}
                </div>)}
            </div>
          </div>

          {/* Footer */}
          <div className="px-6 pb-6 text-center" data-id="element-90">
            <p className="text-sm font-black text-yellow-300 m-0 mb-1" data-id="element-91">
              🏆 Todo en un solo lugar — listo para usar y personalizar
            </p>
            <p className="text-xs text-green-200 m-0" data-id="element-92">
              La decisión más inteligente para avanzar en la carrera sin perder
              tiempo.
            </p>
          </div>
        </div>

        {/* Sin divider — el fondo ya hace la transición */}
      </div>
    </section>;
}